"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAsyncPacketIterator = void 0;
var crypto_js_1 = __importDefault(require("crypto-js"));
var utils_1 = require("./utils");
function getAsyncPacketIterator(_a) {
    var data = _a.data, frameSize = _a.frameSize, kek = _a.kek, chunkSize = _a.chunkSize;
    return __asyncGenerator(this, arguments, function getAsyncPacketIterator_1() {
        var iv, ivWA, kekWA, rawKeyWA, keyDec, key, defaultChunkSize, packetCount, currentChunkSize, uint8DataArray, padding, offset, dataChunk, dataChunkWA, encryptedChunk, encryptedDataChunk, nextIvWA, nextiv;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    iv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
                    ivWA = crypto_js_1.default.lib.WordArray.create(iv);
                    kekWA = crypto_js_1.default.lib.WordArray.create(kek);
                    rawKeyWA = crypto_js_1.default.lib.WordArray.random(8);
                    keyDec = crypto_js_1.default.DES.decrypt({
                        ciphertext: rawKeyWA,
                    }, kekWA, { mode: crypto_js_1.default.mode.ECB, padding: crypto_js_1.default.pad.Pkcs7 });
                    keyDec.sigBytes = 8;
                    key = utils_1.wordArrayToByteArray(keyDec);
                    defaultChunkSize = chunkSize ? chunkSize : 0x00100000;
                    packetCount = 0;
                    currentChunkSize = 0;
                    uint8DataArray = new Uint8Array(data);
                    if (uint8DataArray.length % frameSize !== 0) {
                        padding = frameSize - (uint8DataArray.length % frameSize);
                        uint8DataArray = utils_1.concatUint8Arrays(uint8DataArray, new Uint8Array(Array(padding).fill(0)));
                    }
                    offset = 0;
                    _b.label = 1;
                case 1:
                    if (!(offset < uint8DataArray.length)) return [3 /*break*/, 4];
                    if (packetCount > 0) {
                        currentChunkSize = defaultChunkSize;
                    }
                    else {
                        currentChunkSize = defaultChunkSize - 24;
                    }
                    currentChunkSize = Math.min(currentChunkSize, uint8DataArray.length - offset);
                    dataChunk = uint8DataArray.subarray(offset, offset + currentChunkSize);
                    dataChunkWA = crypto_js_1.default.lib.WordArray.create(dataChunk);
                    encryptedChunk = crypto_js_1.default.DES.encrypt(dataChunkWA, rawKeyWA, {
                        mode: crypto_js_1.default.mode.CBC,
                        iv: ivWA,
                    });
                    encryptedDataChunk = utils_1.wordArrayToByteArray(encryptedChunk.ciphertext);
                    encryptedDataChunk = encryptedDataChunk.subarray(0, currentChunkSize); //encryptedDataChunk.length - 8
                    nextIvWA = crypto_js_1.default.lib.WordArray.create(encryptedDataChunk.subarray(encryptedDataChunk.length - 8, encryptedDataChunk.length));
                    nextiv = utils_1.wordArrayToByteArray(ivWA);
                    return [4 /*yield*/, __await({ key: key, iv: iv, data: encryptedDataChunk })];
                case 2: return [4 /*yield*/, _b.sent()];
                case 3:
                    _b.sent();
                    ivWA = nextIvWA;
                    iv = nextiv;
                    offset = offset + currentChunkSize;
                    packetCount += 1;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getAsyncPacketIterator = getAsyncPacketIterator;
//# sourceMappingURL=encrypt-generator.js.map